async function main() {
  const root = document.querySelector(".isa-root");
  if (!root) return;

  const container = document.createElement("div");
  let isMobile = window.innerWidth <= 768;

  window.addEventListener("resize", () => {
    isMobile = window.innerWidth <= 768;
  });

  const baseUrl = "https://instasync.encircledev.com";

  const shopName = window.Shopify.shop;

  const settingResponse = await (
    await fetch(`${baseUrl}/widget-settings?shopName=${shopName}`)
  ).json();

  if (!!settingResponse && settingResponse == "unauthorized") {
    root.innerHTML = "";
    return;
  }

  const settings = settingResponse?.settings;
  const heading = isMobile
    ? settings.isContentSameAsDesktop
      ? settings.heading
      : settings.headingMobile
    : settings.heading;

  const subHeading = isMobile
    ? settings.isContentSameAsDesktop
      ? settings.subHeading
      : settings.subHeadingMobile
    : settings.subHeading;

  root.innerHTML = `  
    <div class="isa-container isa-heading-wrapper">
        ${!!heading.trim() || !!subHeading.trim() || !!settings.showButton
            ? `<div class="isa-header">
                ${!!heading.trim() ? '<h2 class="isa-heading">' + heading + "</h2>" : ""}
                ${!!subHeading.trim() ? '<p class="isa-subheading">' + subHeading + "</p>" : ""}
                ${!!settings.showButton ? `<a href="${settings.buttonLink || "#"}" class="isa-heading-button isa-header-button">${settings.buttonText}</a>` : ""}
            </div>`
            : ""
        }
        <div class="isa-post-container">
            <div class="isa-post-skeleton"></div>
            <div class="isa-post-skeleton"></div>
            <div class="isa-post-skeleton"></div>
            <div class="isa-post-skeleton"></div>
        </div>
    </div>`;

  const stylesheet = settingResponse?.data?.css || "";

  const instagramAPI = `${baseUrl}/ig/posts?shopName=${shopName}`;
  const form = new URLSearchParams();
  form.append("display", settings.display);
  form.append("limit", isMobile ? settings.numberOfPostsMobile : settings.numberOfPosts);
  const mediaResponse = await fetch(instagramAPI, {
    method: "POST",
    body: form,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  });
  const mediaData = await mediaResponse.json();

  const username = mediaData.username;
  const posts = mediaData.data
    .filter((post) =>
      settings.display == "both"
        ? true
        : post.media_type == "IMAGE" || post.media_type == "CAROUSEL_ALBUM",
    )
    .slice(0, isMobile ? settings.numberOfPostsMobile : settings.numberOfPosts);

  const styles = ` 
    .isa-container {
        --isa-bg-color: ${settings.backgroundColor};
        --isa-content-bg-color: ${settings.contentBackgroundColor};
        --isa-padding-x: ${settings.paddingX}px;
        --isa-padding-y: ${settings.paddingY}px;
        --isa-mobile-padding-x: ${settings.paddingXMobile}px;
        --isa-mobile-padding-y: ${settings.paddingYMobile}px;
        --isa-heading-color: ${settings.headingColor};
        --isa-subheading-color: ${settings.subHeadingColor};
        --isa-header-padding-bottom: ${settings.headerMarginBottom}px;
        --isa-mobile-header-padding-bottom: ${settings.headerMarginBottomMobile}px;
        --isa-rounded-corner: ${settings.roundedCorner}px;
        --isa-mobile-rounded-corner: ${settings.roundedCornerMobile}px;
        --isa-feed-spacing: ${settings.feedSpacing}px;
        --isa-mobile-feed-spacing: ${settings.feedSpacingMobile}px;
        --isa-columns: ${settings.numberOfColumn};
        --isa-mobile-columns: ${settings.numberOfColumnMobile};
        --isa-show-button: ${settings.showButton ? "inline-block" : "none"};
        --isa-button-bg-color: ${settings.buttonBgColor};
        --isa-button-hover-bg-color: ${settings.buttonHoverBgColor};
        --isa-button-text-color: ${settings.buttonTextColor};
        --isa-button-hover-text-color: ${settings.buttonHoverTextColor};
        --isa-arrow-padding: ${settings.arrowPadding}px;
        --isa-mobile-arrow-padding: ${settings.arrowPaddingMobile}px;
        --isa-arrow-border-radius: ${settings.arrowBorderRadius}px;
        --isa-mobile-arrow-border-radius: ${settings.arrowBorderRadiusMobile}px;
        --isa-arrow-background-color: ${settings.arrowBackgroundColor};
        --isa-mobile-arrow-background-color: ${settings.arrowBackgroundColorMobile};
        --isa-arrow-color: ${settings.arrowColor};
        --isa-mobile-arrow-color: ${settings.arrowColorMobile};
        --isa-arrow-display: ${settings.showArrow ? "flex" : "none"};
        --isa-mobile-arrow-display: ${settings.showArrowMobile ? "flex" : "none"};
        --isa-mobile-heading-color: ${settings.headingColorMobile};
        --isa-mobile-subheading-color: ${settings.subHeadingColorMobile};
        --isa-heading-button-margin-top: ${settings.buttonMarginTop}px;
        --isa-button-padding-x: ${settings.buttonPaddingX}px;
        --isa-button-padding-y: ${settings.buttonPaddingY}px;
    }
    ${stylesheet}
    `;

  const htmlTemplate = `<div
        class="isa-container"
        >
           ${!!heading.trim() || !!subHeading.trim() || !!settings.showButton
               ? `<div class="isa-header">
                    ${!!heading.trim() ? '<h2 class="isa-heading">' + heading + "</h2>" : ""}
                    ${!!subHeading.trim() ? '<p class="isa-subheading">' + subHeading + "</p>" : ""}
                    ${!!settings.showButton ? `<a href="${settings.buttonLink || "#"}" class="isa-heading-button isa-header-button">${settings.buttonText}</a>` : ""}
                </div>`
               : ""
           }
        ${getLayout()}
    </div>`;

  const stylesheetEl = document.createElement("style");
  stylesheetEl.textContent = styles;
  document.head.appendChild(stylesheetEl);

  if (settings.design == "template2") {
    document.body
      .querySelector(".isa-main-feed")
      ?.closest(".page-width")
      ?.classList?.remove("page-width");
  }

  container.insertAdjacentHTML("afterbegin", htmlTemplate);
  container.querySelectorAll(".isa-grid-item > a").forEach((item) => {
    item.addEventListener("keydown", async (e) => {
      if (e.target.classList.contains("dragging")) {
        e.preventDefault();
        return;
      }
      if (e.key == "Enter" || e.key == " ") {
        e.preventDefault();
        window.triggerElement = e.target;
        if (settings.onImageClick == "open_instagram")
          window.open(e.target.href, "_blank");
        e.preventDefault();
        if (settings.onImageClick == "open_popup") {
          return openPopup(
            posts.findIndex((post) => post.permalink === e.target.href),
          );
        }
        return;
      }
    });
    item.addEventListener("click", (e) => onClick(e, item.href));
  });
  const isaContainer = container.querySelector(".isa-container");
  if (settings.paddingX < 20) {
    isaContainer.classList.add("isa-default-container-padding");
  }
  if (settings.isArrowSameAsDesktop) {
    isaContainer.classList.add("isa-arrow-style-same-as-desktop");
  }
  if (settings.isContentStyleSameAsDesktop) {
    isaContainer.classList.add("isa-content-style-same-as-desktop");
  }
  if (settings.design === "template2") {
    isaContainer.classList.add("isa-design2");
  } else {
    isaContainer.classList.remove("isa-design2");
  }
  isaContainer.classList.add(
    settings.layout === "grid" ? "isa-grid" : "slider",
  );

  if (settings[isMobile ? "layoutMobile" : "layout"] === "slider")
    initSlider(container);

  root.innerHTML = "";
  root?.appendChild(container);

  window.addEventListener("resize", resize);
  setTimeout(resize, 0);

  function resize() {
    container
      .querySelector(".isa-slider")
      ?.style?.setProperty(
        "--isa-slider-width",
        `${container.querySelector(".isa-slider")?.getBoundingClientRect()?.width}px`,
      );
  }

  function onClick(e, link) {
    if (e.target.classList.contains("dragging")) {
      e.preventDefault();
      return;
    }
    if (settings.onImageClick == "open_instagram") return;
    e.preventDefault();
    if (settings.onImageClick == "open_popup") {
      return openPopup(posts.findIndex((post) => post.permalink === link));
    }
    return;
  }

  function getLayout() {
    if (settings[isMobile ? "layoutMobile" : "layout"] == "grid") {
      const feedsHtml = posts.map(feedItem).join("");
      return `<div class="isa-grid">${feedsHtml}</div>`;
    } else {
      const wrapper = (slideItem) =>
        `<div class="isa-slide">${slideItem}</div>`;
      const feedsHtml = posts
        .map((post, index) => wrapper(feedItem(post, index)))
        .join("");
      return sliderBoiler(feedsHtml);
    }
  }

  function feedItem(post, index) {
    let alt = "";
    if (post?.caption) {
      alt += post?.caption?.slice(0, 50);
      if (post?.caption?.length > 50) {
        alt += "...";
      }
    } else {
      alt += "image " + index;
    }
    return `<div class="isa-grid-item ${post.media_type == "VIDEO" ? "video" : ""}">
            <a href="${post.permalink}" target="_blank" draggable="false" ${settings.layout === "grid" ? "" : `tabindex="0"`}>
                <img
                    src="${post.media_type == "VIDEO" ? post.thumbnail_url : post.media_url}"
                    alt="${alt}"
                    draggable="false"
                    loading="lazy"
                />
            </a>
       </div>`;
  }

  function sliderBoiler(slides) {
    return `<div class="isa-slider">
    <button class="isa-slider-btn isa-slider-btn-prev" aria-label="Prev">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="isa-slider-btn-icon">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path>
        </svg>
    </button>
        <div class="isa-track">
            <div class="isa-slides" style="transform: translateX(0px)">
                ${slides}
            </div>
        </div>
        <button class="isa-slider-btn isa-slider-btn-next" aria-label="Next">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                class="isa-slider-btn-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
            </svg>
        </button>
    </div>`;
  }

  function openPopup(postIndex) {
    document.body.classList.add("isa-overflow-hidden");
    const animEl =
      document.body
        .querySelector(".isa-main-feed")
        .closest(".animate--slide-in") ||
      document.body.querySelector(".isa-main-feed").closest(".animateSlideIn");
    if (animEl) {
      animEl.classList?.remove("animate--slide-in");
      animEl.classList?.add("animateSlideIn");
    }

    const post = posts[postIndex];

    const media = (media) => {
      if (media?.media_type == "VIDEO") {
        return `<video class="isa-media" src="${media.media_url}" autoplay="true" controls controlsList="nodownload"></video>`;
      }
      let alt = "";
      if (media?.caption) {
        alt += media?.caption?.slice(0, 50);
        if (media?.caption?.length > 50) {
          alt += "...";
        }
      } else {
        alt = "image";
      }
      return `<img class="isa-media" src="${media.media_url}" alt="${alt}" loading="lazy" />`;
    };

    const popupHtml = `
        <div class="isa-feed-popup-overlay isa-popup-overlay">
        <div class="isa-popup-container">
            <button class="popup-btn popup-btn-prev" aria-label="popup previous btn" tabindex="4">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                class="popup-btn-icon"
            >
                <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
                ></path>
            </svg>
            </button>
            <div class="isa-feed-popup-content isa-popup">
            <button class="isa-feed-popup-close-btn" aria-label="Close" tabindex="1">
                <svg
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414z"
                    fill="#0D0D0D"
                ></path>
                </svg>
            </button>
            <div>
                <div class="isa-feed-popup-image">
                    ${media(post)}
                    <div class="isa-feed-popup-post-caption-mobile">
                        <p>${post.caption || ""}</p>
                    </div>
                </div>
                <div class="isa-feed-popup-details">
                <div class="isa-feed-popup-user-info">
                    <a class="isa-feed-icon-link" href="${post.permalink}" tabindex="2" target="_blank"
                    ><div class="isa-feed-popup-user-profile"><span>${username.charAt(0)}</span></div></a
                    >
                    <div>
                    <p>
                        <a class="isa-feed-link" href="${post.permalink}" tabindex="3" target="_blank"
                        >${username}</a
                        >
                    </p>
                    </div>
                </div>
                <hr />
                <div class="isa-feed-popup-post-caption">
                    <p>${post.caption || ""}</p>
                </div>
                </div>
            </div>
            </div>
            <button class="popup-btn popup-btn-next" aria-label="popup next btn" tabindex="5">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                class="popup-btn-icon"
            >
                <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
                ></path>
            </svg>
            </button>
        </div>
        </div>`;

    isaContainer.insertAdjacentHTML("beforeend", popupHtml);

    const popupOverlay = isaContainer.querySelector(".isa-feed-popup-overlay");
    const popupContainer = isaContainer.querySelector(".isa-popup-container");
    const removePopup = isaContainer.querySelector(
      ".isa-feed-popup-overlay .isa-feed-popup-close-btn",
    );
    const popupBtnPrev = popupOverlay.querySelector(".popup-btn-prev");
    const popupBtnNext = popupOverlay.querySelector(".popup-btn-next");
    const mediaContainer = popupOverlay.querySelector(".isa-feed-popup-image");
    const captionElMobile = popupOverlay.querySelector(
      ".isa-feed-popup-post-caption-mobile p",
    );
    const captionEl = popupOverlay.querySelector(
      ".isa-feed-popup-post-caption p",
    );
    const feedIconLink = popupOverlay.querySelector(".isa-feed-icon-link");
    const feedLink = popupOverlay.querySelector(".isa-feed-link");
    const popupEl = popupOverlay.querySelector(".isa-feed-popup-content");
    popupBtnPrev.addEventListener("click", () => changePost(-1));
    popupBtnNext.addEventListener("click", () => changePost(1));

    removePopup.focus();

    const disablePopupBtn = () => {
      if (postIndex <= 0) {
        popupBtnPrev.setAttribute("disabled", true);
      } else {
        popupBtnPrev.removeAttribute("disabled");
      }

      if (postIndex + 1 >= posts.length) {
        removePopup.focus();
        popupBtnNext.setAttribute("disabled", true);
      } else {
        popupBtnNext.removeAttribute("disabled");
      }
    };
    disablePopupBtn();

    const changePost = (offset) => {
      postIndex = postIndex + offset;
      const post = posts[postIndex];
      mediaContainer.querySelector(".isa-media").remove();
      mediaContainer.insertAdjacentHTML("afterbegin", media(post));
      captionElMobile.innerText = post.caption || "";
      captionEl.innerText = post.caption || "";
      feedIconLink.href = post.permalink || "";
      feedLink.href = post.permalink || "";
      disablePopupBtn();
      let element = document.querySelectorAll(".isa-feed-popup-post-caption");
      let mobileElement = document.querySelectorAll(".isa-feed-popup-content");
      element.forEach((element) => {
        element.scrollTop = -element.scrollHeight;
      });
      mobileElement.forEach((element) => {
        element.scrollTop = -element.scrollHeight;
      });
    };

    const handler = (e) => {
      if (
        popupBtnPrev &&
        !popupBtnPrev.contains(e.target) &&
        popupBtnNext &&
        !popupBtnNext.contains(e.target) &&
        popupEl &&
        !popupEl.contains(e.target)
      ) {
        closePopup(e);
      }
    };

    const video = document.querySelector("video");
    if (video) {
      video.play();
    }

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    const focusableSelectors = [
      "a[href]",
      "area[href]",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "button:not([disabled])",
      "datalist:not([disabled])",
      "object",
      "embed",
      '[tabindex]:not([tabindex="-1"])',
      "[contenteditable]",
      "iframe",
    ].join(", ");

    function tabFocusHandler(event) {
      if (event.key === "Escape") {
        closePopup();
      }
      if (event.key === "Tab") {
        const allFocusableElements =
          popupContainer &&
          [...popupContainer.querySelectorAll(focusableSelectors)].sort(
            (a, b) => a.tabIndex - b.tabIndex,
          );
        const firstElement = allFocusableElements.find(
          (a) => a.disabled != true,
        );
        const lastElement = allFocusableElements.findLast(
          (e) => e.disabled != true,
        );
        if (event.shiftKey) {
          if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }
    }
    document.addEventListener("keydown", tabFocusHandler);
    removePopup.addEventListener("click", closePopup);

    function closePopup() {
      popupOverlay.remove();
      document.body.classList.remove("isa-overflow-hidden");
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
      document.removeEventListener("keydown", tabFocusHandler);
      if (window && window.triggerElement) window.triggerElement.focus();
    }
  }

  function initSlider(container) {
    let currentSlideIndex = 0;
    let isDragging = false;
    let isMoved = false;
    let startPosition = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;

    const slider = container.querySelector(".isa-slider");
    const slides = container.querySelector(".isa-slides");
    const sliderBtnPrev = container.querySelector(".isa-slider-btn-prev");
    const sliderBtnNext = container.querySelector(".isa-slider-btn-next");

    sliderBtnPrev.addEventListener("click", () => swipe(-1));
    sliderBtnPrev.setAttribute("disabled", true);
    sliderBtnNext.addEventListener("click", () => swipe(1));

    if (
      settings[isMobile ? "numberOfColumnMobile" : "numberOfColumn"] ===
        settings[isMobile ? "numberOfPostsMobile" : "numberOfPosts"] ||
      posts.length <=
        settings[isMobile ? "numberOfColumnMobile" : "numberOfColumn"]
    ) {
      sliderBtnNext.setAttribute("disabled", true);
    }

    const startDrag = (event) => {
      if (event.which != 1 && event.type == "mousedown") return;
      if (event.type === "touchstart") {
        startPosition = event.touches[0].clientX;
      } else {
        startPosition = event.clientX;
      }
      isDragging = true;

      const transformMatrix = window
        .getComputedStyle(slides)
        .getPropertyValue("transform");
      if (transformMatrix !== "none") {
        currentTranslate = parseFloat(transformMatrix.split(",")[4]);
      }

      slides.style.transition = "none";
    };

    const drag = (event) => {
      if (!isDragging) return;
      if (!isMoved) {
        isMoved = true;
      }

      container.querySelectorAll(".isa-slide a img").forEach((el) => {
        if (!el.classList.contains("dragging")) {
          el.classList.add("dragging");
        }
      });

      const currentPosition =
        event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
      const deltaX = currentPosition - startPosition;
      const newTranslate = currentTranslate + deltaX;

      slides.style.transform = `translateX(${newTranslate}px)`;

      prevTranslate = newTranslate;
    };

    const endDrag = (event) => {
      if (!isDragging) return;
      isDragging = false;
      if (!isMoved) return;
      isMoved = false;

      setTimeout(() => {
        container.querySelectorAll(".isa-slide a img").forEach((el) => {
          el.classList.remove("dragging");
        });
      }, 300);

      const endPosition =
        event.type === "touchend"
          ? event.changedTouches[0].clientX
          : event.clientX;
      const deltaX = endPosition - startPosition;
      if (deltaX > 50) {
        goToSlide(-1);
      } else if (deltaX < -50) {
        goToSlide(1);
      } else {
        goToSlide(0);
      }

      slides.style.transition = "transform 0.3s ease";
    };

    const goToSlide = (indexOffset) => {
      const slideWidth = slides.firstElementChild.clientWidth;
      const slidesToShow = +(slider.clientWidth / slideWidth).toFixed();

      const currentIndex = -Math.round(prevTranslate / slideWidth);
      let newIndex = currentIndex + indexOffset;

      newIndex = Math.max(
        0,
        Math.min(slides.children.length - slidesToShow, newIndex),
      );

      currentSlideIndex = newIndex;
      slides.style.transform = `translateX(${-(newIndex * slideWidth)}px)`;
      disableBtn();
    };

    const swipe = (direction) => {
      const slideWidth = slides.firstElementChild.clientWidth;
      const slidesToShow = +(slider.clientWidth / slideWidth).toFixed();
      const totalSlides = slides.children.length;

      currentSlideIndex += direction;
      if (currentSlideIndex < 0) {
        currentSlideIndex = 0;
      } else if (currentSlideIndex > totalSlides - slidesToShow) {
        currentSlideIndex = totalSlides - slidesToShow;
      }
      slides.style.transition = "transform 0.3s ease";
      slides.style.transform = `translateX(${-(currentSlideIndex * slideWidth)}px)`;
      disableBtn();
    };

    const disableBtn = () => {
      if (currentSlideIndex < 1) {
        sliderBtnPrev.setAttribute("disabled", true);
      } else {
        sliderBtnPrev.removeAttribute("disabled");
      }
      if (
        +(
          currentSlideIndex -
          (posts.length -
            settings[isMobile ? "numberOfColumnMobile" : "numberOfColumn"])
        ).toFixed() >= 0 ||
        settings[isMobile ? "numberOfColumnMobile" : "numberOfColumn"] ===
          posts.length ||
        posts.length <=
          settings[isMobile ? "numberOfColumnMobile" : "numberOfColumn"]
      ) {
        sliderBtnNext.setAttribute("disabled", true);
      } else {
        sliderBtnNext.removeAttribute("disabled");
      }
    };

    slides.addEventListener("keydown", (event) => {
      if (event.key === "Tab") {
        const totalSlides = slides.children.length;

        if (event.shiftKey) {
          if (currentSlideIndex > 0) {
            swipe(-1);
          }
        } else {
          if (currentSlideIndex < totalSlides - 1) {
            swipe(1);
          }
        }
        slides.children[currentSlideIndex].focus();
      }
    });

    slides?.firstElementChild
      ?.querySelector("a")
      ?.addEventListener("focus", () => {
        goToSlide(-1);
        currentSlideIndex = 0;
      });

    slides?.lastElementChild
      ?.querySelector("a")
      ?.addEventListener("focus", () => {
        slides?.lastElementChild.focus();
        currentSlideIndex = slides.children.length - 1;
      });

    slides.addEventListener("mousedown", startDrag);
    slides.addEventListener("touchstart", startDrag);
    document.addEventListener("mousemove", drag);
    document.addEventListener("mouseup", endDrag);
    document.addEventListener("touchmove", drag);
    document.addEventListener("touchend", endDrag);
  }
}

let screen = window.innerWidth <= 768 ? "mobile" : "desktop";

window.addEventListener("resize", () => {
  const screenWidth = window.innerWidth;
  if (screen == "mobile" && screenWidth >= 768) {
    screen = "desktop";
    return rerender();
  }
  if (screen == "desktop" && screenWidth < 768) {
    screen = "mobile";
    return rerender();
  }
});

function rerender() {
    document.body.querySelector(".isa-root").innerHTML = "";
  main();
}

main();
document.addEventListener("DOMContentLoaded", main);